import React from 'react';
import Icon from '../assets/icons';
import DoteDivider from '../common/DoteDivider';
import {
  CaseLinksContainer,
  Description,
  IconWrapper,
  Item,
  LinkItem,
} from './styles';

type TCaseLinks = {
  author: string;
  editor: string;
  games: number;
};

const CaseLinks = ({ author, editor, games }: TCaseLinks) => (
  <CaseLinksContainer>
    {author && (
      <>
        <Item>
          <IconWrapper>
            <Icon variant='user' />
          </IconWrapper>
          <LinkItem>{author}</LinkItem> <Description>author</Description>
        </Item>
        <DoteDivider />
      </>
    )}
    {editor && (
      <>
        <Item>
          <IconWrapper>
            <Icon variant='user' />
          </IconWrapper>
          <LinkItem>{editor}</LinkItem> <Description>editor</Description>
        </Item>
        <DoteDivider />
      </>
    )}
    <Item>
      <IconWrapper>
        <Icon variant='game' />
      </IconWrapper>
      <LinkItem>0 games</LinkItem>
    </Item>
  </CaseLinksContainer>
);

export default CaseLinks;
